export class ProfileSettingsSceneModel {

    public userName: string
    public profilePictureUrl: string
    public isUploading: boolean = false
    public hasUploadError: boolean = false

}